import React, { Suspense, lazy } from "react";
import { withStyles } from "@material-ui/core";
import { withRouter, Redirect } from "react-router-dom";
import { AppLoading } from "../../../loaders/loaders";
import styles from "../moduleViewstyles";
import { withUserProfile } from "../../../userProfile/userProfileContext";
import { compose } from "recompose";
import appConstant from "../../../appConstants";
import { trackEvent } from "../../common/AppInsightsEventTracking";
import ReportList from "./ReportList";
import { withFeatureFlags } from "../../../userProfile/featureFlagsContext";

const DockCompliance = lazy(() => import("./DockCompliance"));
const IBPlanningSummary = lazy(() => import("./IBPlanningSummary/index"));
const ProHistory = lazy(() => import("./ProHistory/ProHistoryGrid"));
const KPISummary = lazy(() => import("./KPISummary/index"));
const DuplicateCustomers = lazy(() => import("./DuplicateCustomers/index"));
const NextStopComplianceReports = lazy(() =>
  import("./NextStopCompliance/index")
);
const DriverPerformanceHistoricReport = lazy(() =>
  import("./DriverPerformance/HistoricReport/FilterFormPage")
);

const MergedCustomersReport = lazy(()=>import("./MergedCustomers"))
const ShipmentsEventStream = lazy(() => import("./ShipmentsEventStream"));
const UsageReport = lazy(() => import("./UsageReport/index"));

class Reports extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeModule: this.props.match.url,
      showReportsList: true,
    };
    this.enableNextStopComplianceReport =
      this.props.featureFlags.isFeatureEnabled(
        appConstant.features.EnableNextStopComplianceReport
      );
    this.enableDriverPerformanceHistoricReport =
      this.props.featureFlags.isFeatureEnabled(
        appConstant.features.EnableDriverPerformanceHistoricReport
      );
  }

  getSubComponentModule = (activeModule) => {
    //Log Telemetry
    const userProfile = this.props.userData.userProfile;
    const { isAdmin } = userProfile;
    trackEvent("ReportsView", userProfile, { report: activeModule });
    const { NAV_URLS } = appConstant;
    switch (activeModule) {
      case NAV_URLS.REPORT_IBPSUMMARY:
        return isAdmin ? (
          <IBPlanningSummary />
        ) : (
          <Redirect to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_PRO_HISTORY:
        return <ProHistory />;
      case NAV_URLS.REPORT_DOCK_COMPLIANCE:
        return isAdmin ? (
          <DockCompliance />
        ) : (
          <Redirect to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_KPI_SUMMARY:
        return <KPISummary />;
      case NAV_URLS.NEXT_STOP_COMPLIANCE:
        return this.enableNextStopComplianceReport ? (
          <NextStopComplianceReports
            hideReportsListItem={this.hideReportsListItem}
          />
        ) : (
          <Redirect to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_DUPLICATE_CUSTOMERS:
        return <DuplicateCustomers glEventHub={this.props.glEventHub} />;
      case NAV_URLS.REPORT_MERGED_CUSTOMERS:
        return <MergedCustomersReport glEventHub={this.props.glEventHub} />;
      case NAV_URLS.REPORT_DRIVER_PERFORMANCE:
        return this.enableDriverPerformanceHistoricReport ? (
          <DriverPerformanceHistoricReport/>
        ) : (
          <Redirect to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      case NAV_URLS.REPORT_SHIPMENTS_EVENT_STREAM:
        return <ShipmentsEventStream />;
      case NAV_URLS.REPORT_USAGE_REPORT:
        return isAdmin ? (
          <UsageReport />
        ) : (
          <Redirect to={appConstant.NAV_URLS.ACCESS_DENIED} />
        );
      default:
        return "URL not found";
    }
  };

  hideReportsListItem = (value) => {
    this.setState({ showReportsList: value });
  };

  render() {
    const { classes } = this.props;
    const { activeModule, showReportsList } = this.state;
    const moduleStyleClasses = showReportsList
      ? `${classes.rightSection} ${classes.reportsRightSection} ${classes.extraPadding}`
      : `${classes.reportsFullSection} ${classes.fullSection} ${classes.extraPadding}`;
    return (
      <div className={classes.settingsContainer}>
        {showReportsList && (
          <header className={classes.settingsModuleHeader}>Reports</header>
        )}
        <div className={classes.settingsModuleContent}>
          {showReportsList && (
            <ReportList
              activeModule={activeModule}
              enableNextStopComplianceReport={
                this.enableNextStopComplianceReport
              }
              enableDriverPerformanceHistoricReport={this.enableDriverPerformanceHistoricReport}
            />
          )}
          <div className={moduleStyleClasses}>
            <Suspense fallback={<AppLoading />}>
              {this.getSubComponentModule(activeModule)}
            </Suspense>
          </div>
        </div>
      </div>
    );
  }
}
export default compose(
  withStyles(styles),
  withUserProfile,
  withRouter,
  withFeatureFlags
)(Reports);
